export default __webpack_public_path__ + "static/media/gallery_02.e9889c52.jpg";